module.exports = "../fonts/facebook_enter.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebook_enter.svg
// module id = 96
// module chunks = 0